// extracted by mini-css-extract-plugin
module.exports = {"container":"styles__container___AhEYG","title":"styles__title___jG43S","close":"styles__close___1V-4l","icon":"styles__icon___3N5Ye","content":"styles__content___1uB5A"};